module.exports = __webpack_public_path__ + "img/Plinths-and-Pedestals.c8d12e5a.jpg";